import config from '../config';
import isExpectedServiceWorkerError from './serviceWorkerErrors';

function urlB64ToUint8Array(base64String: string) {
  const padding = '='.repeat((4 - (base64String.length % 4)) % 4);
  const base64 = (base64String + padding)
    .replace(/-/g, '+')
    .replace(/_/g, '/');

  const rawData = window.atob(base64);
  const outputArray = new Uint8Array(rawData.length);

  // eslint-disable-next-line no-plusplus
  for (let i = 0; i < rawData.length; ++i) {
    outputArray[i] = rawData.charCodeAt(i);
  }
  return outputArray;
}

export default async function subscribeToPushNotification() {
  if (typeof Notification !== 'undefined' && Notification.permission === 'denied') {
    return undefined;
  }

  if ('serviceWorker' in navigator) {
    try {
      const registration = await navigator.serviceWorker.ready;
      if (registration.pushManager) {
        const subscription = await registration.pushManager.subscribe({
          userVisibleOnly: true,
          applicationServerKey: urlB64ToUint8Array(config.PushKey),
        });
        return subscription;
      }
      return undefined;
    } catch (error) {
      if (isExpectedServiceWorkerError(error)) {
        return undefined;
      }

      console.error('Error during service worker registration', error);
    }
  }
  return undefined;
}
